import React from 'react';
import styled from '@emotion/styled';
import { Stack, Box, Typography, Button } from '@mui/material';
import { logoutAction } from '../../auth/func/logoutAction';
import { Link, useLoaderData } from 'react-router-dom';
import {
  ConfirmItem,
  ConfirmItemLabel as _ConfirmItemLabel,
  ConfirmItemValue,
} from './ConfirmItem';
import { useTranslation } from 'react-i18next';
import { Title } from '../../../components/Atoms/Title';
import { authType } from '../types';
import useFetchUser from '../hooks/useFetchUser';
import { formatDateStringToYearMonthDate } from '../../../utils/timeRelatedFunctions';
import { useIsMobile } from '../../../hooks/useIsMobile';

const ContentBox = styled(Box)`
  width: 50%;
  text-align: left;
`;

const ConfirmItemLabel = styled(_ConfirmItemLabel)`
  min-width: 240px;
`;

export const ViewClientPage: React.FC = () => {
  const authInfo = useLoaderData() as authType;
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const { user } = useFetchUser(authInfo.user.cognito_username);
  const isMobile = useIsMobile();

  // ログアウトボタンハンドラ
  const handleLogout = async () => {
    await logoutAction();
  };

  return (
    <Box style={{ padding: isMobile ? '16px' : '24px 16px 0px 24px' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Title>{t('pages.user.title')}</Title>

        <Button
          variant="contained"
          color="success"
          onClick={handleLogout}
          size='small'
          sx={{ width: 120 }}
        >
          {t('common.label.logout', 'ログアウト')}
        </Button>
      </Stack>
      <Stack sx={{ mt: 3 }}>
        <ContentBox style={{ width: isMobile ? '100%' : '70%' }}>
          <Stack sx={{ pl: isMobile ? 0 : 6 }} spacing={2}>
            {/* 各<ConfirmItem>などのコンポーネントも必要に応じて型を追加する */}
            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.email')}</ConfirmItemLabel>
              <ConfirmItemValue>{user && user.email}</ConfirmItemValue>
            </ConfirmItem>

            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.username')}</ConfirmItemLabel>
              <ConfirmItemValue>
                {user && user.name}
                <small>{language === 'ja' ? '様' : ''}</small>
              </ConfirmItemValue>
            </ConfirmItem>

            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.customer')}</ConfirmItemLabel>
              <ConfirmItemValue>{user && user.client.company_name}</ConfirmItemValue>
            </ConfirmItem>

            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.department')}</ConfirmItemLabel>
              <ConfirmItemValue>{user && user.department}</ConfirmItemValue>
            </ConfirmItem>

            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.plan')}</ConfirmItemLabel>
              <ConfirmItemValue>
                {(user && user.client.latest_order && user.client.latest_order.plan) ||
                  t('common.label.free')}
              </ConfirmItemValue>
            </ConfirmItem>

            <ConfirmItem>
              <ConfirmItemLabel>{t('common.label.effectivedAt')}</ConfirmItemLabel>
              <ConfirmItemValue>
                {user &&
                  user.client.latest_order &&
                  formatDateStringToYearMonthDate(user.client.latest_order.contract_end_date || '')}
              </ConfirmItemValue>
            </ConfirmItem>

            <Typography style={{ marginTop: '32px' }}>
              {language === 'ja' ? (
                <>
                  ユーザー情報を変更する場合は、<Link to="/prediction/contact">お問い合わせ</Link>
                  からご連絡下さい。
                  <br />
                  <br />
                  また、予報データをご覧いただける有償プランについても、お気軽に<Link to="/prediction/contact">お問い合わせ</Link>ください。
                </>
              ) : (
                <>
                  To change your user information, please contact us via{' '}
                  <Link to="/prediction/contact">Contact Us</Link>.
                </>
              )}
            </Typography>
          </Stack>
        </ContentBox>
      </Stack>
    </Box>
  );
};

export default ViewClientPage;
